/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WidgetFavoriteRequest
 */
export interface WidgetFavoriteRequest {
    /**
     * 
     * @type {string}
     * @memberof WidgetFavoriteRequest
     */
    key: string;
}

/**
 * Check if a given object implements the WidgetFavoriteRequest interface.
 */
export function instanceOfWidgetFavoriteRequest(value: object): value is WidgetFavoriteRequest {
    if (!('key' in value) || value['key'] === undefined) return false;
    return true;
}

export function WidgetFavoriteRequestFromJSON(json: any): WidgetFavoriteRequest {
    return WidgetFavoriteRequestFromJSONTyped(json, false);
}

export function WidgetFavoriteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetFavoriteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
    };
}

export function WidgetFavoriteRequestToJSON(json: any): WidgetFavoriteRequest {
    return WidgetFavoriteRequestToJSONTyped(json, false);
}

export function WidgetFavoriteRequestToJSONTyped(value?: WidgetFavoriteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
    };
}

